import { Store } from "pullstate";

const INITIAL_STATE = {
    hasDefaultPremiumEditing: false,
    hasDefaultClientImageApproval: false,
    isFoodService: false,
    sendToGdsn: false,
};

const ShipmentProductOptionStore = new Store(INITIAL_STATE);

export const updateHasDefaultPremiumEditing = (hasDefaultPremiumEditing) => {
    ShipmentProductOptionStore.update((s) => {
        s.hasDefaultPremiumEditing = hasDefaultPremiumEditing;

        return s;
    });
};

export const updateHasDefaultClientImageApproval = (hasDefaultClientImageApproval) => {
    ShipmentProductOptionStore.update((s) => {
        s.hasDefaultClientImageApproval = hasDefaultClientImageApproval;

        return s;
    });
};

export const updateIsFoodservice = (isFoodService) => {
    ShipmentProductOptionStore.update((state) => {
        state.isFoodService = isFoodService;

        return state;
    });
};

export const updateSendToGdsn = (sendToGdsn) => {
    ShipmentProductOptionStore.update((state) => {
        state.sendToGdsn = sendToGdsn;

        return state;
    });
};

export default ShipmentProductOptionStore;
